import { Link } from 'gatsby';
import Img from 'gatsby-image';
import _ from 'lodash';
import { lighten } from 'polished';
import React from 'react';
import { css } from '@emotion/react';
import { colors } from '../../../styles/colors';
import { PageContext } from '../../../templates/packages/packageDetail';
export interface PostCardProps {
  post: PageContext;
  large?: boolean;
}
export const PackagesCard: React.FC<PostCardProps> = ({ post, large = false }) => {
  return (
    <div className=" card col-lg-3 py-2 m-3" style={{ width: '20rem' }}>
    {post.frontmatter.image && (
         <Link className="img-wrapper post-card-image-link"
         to={`/website-packages${post.fields.slug}`}>
             {post.frontmatter?.image?.childImageSharp?.fluid && (
               <Img
                 alt={`${post.frontmatter.title} cover image`}
                 style={{ height: '100%' }}
                 fluid={post.frontmatter.image.childImageSharp.fluid}
                 className="zoom-on-hover"
               />
             )}
         </Link>
       )}
           <div className="card-body">
             <p className="card-text">
             {post.frontmatter.excerpt || post.excerpt}
             </p>
           </div>
           <hr/>
           <div className="row">
             <div style={{color: '#1AAD88',fontSize:'1.4rem'}}className="col">
               <p>₹ {post.frontmatter.price}</p>
             </div>
             <div className="col">
             {post.frontmatter.tags[0]}
             </div>
           </div>
         </div>
    
  );
};


export const StaticAvatar = css`
  display: block;
  overflow: hidden;
  margin: 0 0 0 -6px;
  width: 34px;
  height: 34px;
  border: #fff 2px solid;
  border-radius: 100%;

  @media (prefers-color-scheme: dark) {
    /* border-color: color(var(--darkgrey) l(+2%)); */
    border-color: ${lighten('0.02', colors.darkgrey)};
  }
`;

export const AuthorProfileImage = css`
  display: block;
  width: 100%;
  height: 100%;
  /* background: color(var(--lightgrey) l(+10%)); */
  background: ${lighten('0.1', colors.lightgrey)};
  border-radius: 100%;
  object-fit: cover;

  @media (prefers-color-scheme: dark) {
    background: ${colors.darkmode};
  }
`;
